export const GET_A_CALL_IMG = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/contact-sales/Get_Call.svg";
export const GET_A_CALL_ALT = "Get a call image";
export const BOOK_A_MEETING_IMG = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/contact-sales/Book_Meeting.svg";
export const BOOK_A_MEETING_ALT = "Book a meeting image";
export const PARAM_FROM_KEY = "from";
export const PARAM_FROM_VALUE = "amanda";
export const DEFAULT_TIMEOUT_VALUE = 600000;
export const GET_A_CALL_TIMEOUT_KEY = "getACallTimeout";
export const GET_A_CALL_TIMESTAMP_KEY = "getACallTimestamp";
export const AMANDA_CALL_LINK = "amandaCallLink";
export const AMANDA_TIMOUT = "amandaCallLinkExpirationInMS";
export const EMAIL_FOR_HUBSPOT_AMANDA_REQUEST = "userEmailForAmanda";
export const USER_FIRST_NAME = "userFirstName";
export const AMANDA_HS_FORM_ID = "39feff83-3d21-49c2-be03-4961de873f82";
export const AMANDA_HS_PORTAL_ID = "5945317";
export const MINIMUM_FETCH_REQUEST_LOADING_TIME_MS = 2000;
